import React from 'react';
import { Box } from '@mui/material';
import { useAppSelector } from '../../../../../redux/hooks';
import { Bone } from '../../../../../components/ui/DashboardSkeletons';
import MemberPathwaySkeleton from './MemberPathwaySkeleton';
import MemberLearningLifecycleDashboard from './MemberLearningLifecycleDashboard';

/**
 * Member home. The Learning Framework dashboard is GA for every org — the
 * `memberLearningLifecycleDashboard` org flag is no longer read, so a member
 * whose org details failed to load no longer falls back to the legacy Program
 * Portfolio. The pathway's own data fetches carry the loading state; the
 * skeleton below only covers the first paint while the org details resolve.
 */
const MemberPortfolioSwitch: React.FC = () => {
  const orgDetailsResolved = useAppSelector((state) => state.orgDetails.data !== undefined || state.orgDetails.error);
  if (!orgDetailsResolved) {
    return (
      <Box sx={{ height: '100%', width: '100%', display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <Bone width="45%" height={36} />
        <MemberPathwaySkeleton />
      </Box>
    );
  }
  return <MemberLearningLifecycleDashboard />;
};

export default MemberPortfolioSwitch;
